<div class="container" id="top">
  <h2>Institutional Account</h2>
  <mfk-table highlight="iact"></mfk-table>

  <table cellpadding="0" cellspacing="3" class="table" width="100%" border="0" summary="Details relating to Institutional Account.">
    <tbody>
      <tr>
        <th>Length:</th>
        <td style="display: inline-block; padding-right: 2em;">
            University (Corp 10): <br />
            Hospital (Corp 30):
         </td>
         <td style="display: inline-block;">
            4 characters <br />
            7 characters
         </td>
      </tr>
      <tr>
        <th>Description:</th>
        <td colspan="2">The institutional account is the primary accounting element in the Master File Key. This element
          identifies revenues, expenses, assets, liabilities and fund balances. The Hospital (Corp 30) and the College
          of
          Medicine (Org 17) has defined the organizational account as a sub-element to the institutional account.</td>
      </tr>
      <tr>
        <th>Required:</th>
        <td td colspan="2">Yes</td>
      </tr>
      <tr>
        <th>Restrictions:</th>
        <td td colspan="2">Accounting &amp; Financial Reporting must approve a new institutional account before adding it to the Chart
          of
          Values database. Institutional accounts are restricted in their use to certain funds. For Corp 30 the system
          will treat the combination of institutional and organizational account as one element for validation purposes.
        </td>
      </tr>
      <tr>
        <th>Default&nbsp;Value:</th>
        <td td colspan="2">This element will always require a valid institutional account value.</td>
      </tr>
      <tr>
        <th>Example:</th>
        <td td colspan="2">
            The following are examples of institutional accounts for Corp 10 and institutional/organizational account
            for
            Corp 30:
            <div class="border border-secondary">
                <table cellpadding="0" cellspacing="3" class="table table-hover table-sm mb-0" width="100%" summary="Examples of institutional accounts for Corp 10.">
                    <thead>
                    <tr class="bg-dark text-white">
                        <th colspan="2">Corp 10</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th width="20%">Institutional Account</th>
                        <th width="80%">Description</th>
                    </tr>
                    <tr>
                        <td width="20%">6070</td>
                        <td width="80%">Office Supplies</td>
                    </tr>
                    <tr>
                        <td width="20%">6115</td>
                        <td width="80%">Laboratory Supplies</td>
                    </tr>
                    <tr>
                        <td width="20%">6145</td>
                        <td width="80%">Fuel</td>
                    </tr>
                    <tr>
                        <td width="20%">6199</td>
                        <td width="80%">Other Supplies</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="border border-secondary">
                <table cellpadding="0" cellspacing="3" class="table table-hover table-sm mb-0" width="100%" summary="Examples of institutional accounts for Corp 30.">
                    <thead>
                        <tr class="bg-dark text-white">
                            <th colspan="2">Corp 30 (includes the organizational account as a sub-element)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th width="20%">Institutional/Organizational Account</th>
                            <th width="80%">Description</th>
                        </tr>
                        <tr>
                            <td width="20%">6070 110</td>
                            <td width="80%">Off Sup-Computer/Printer Supplies</td>
                        </tr>
                        <tr>
                            <td width="20%">6115 050</td>
                            <td width="80%">Lab Supplies (Non-clinical)-Animal</td>
                        </tr>
                        <tr>
                            <td width="20%">6145 000</td>
                            <td width="80%">Fuel</td>
                        </tr>
                        <tr>
                            <td width="20%">6199 600</td>
                            <td width="80%">Other Supplies-Hardware &amp; Tools</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </td>
      </tr>
      <tr>
          <th class="vaTop">Institutional Account Range:</th>
          <td>
              <div class="border border-secondary">
                  <table cellpadding="0" cellspacing="3" class="table table-hover table-sm mb-0" width="100%" summary="Blocking scheme for institutional accounts.">
                      <tbody>
                          <tr>
                              <th width="20%">Institutional Account Range</th>
                              <th width="80%">Description</th>
                          </tr>
                          <tr>
                              <td width="20%">1000's</td>
                              <td width="80%">Assets</td>
                          </tr>
                          <tr>
                              <td width="20%">2000-2499</td>
                              <td width="80%">Liabilities</td>
                          </tr>
                          <tr>
                              <td width="20%">2500-2999</td>
                              <td width="80%">Fund Balance</td>
                          </tr>
                          <tr>
                              <td width="20%">3000's</td>
                              <td width="80%">Revenues/Additions</td>
                          </tr>
                          <tr>
                              <td width="20%">4000's</td>
                              <td width="80%">Revenues/Additions</td>
                          </tr>
                          <tr>
                              <td width="20%">5000's</td>
                              <td width="80%">Expenditures/Deductions</td>
                          </tr>
                          <tr>
                              <td width="20%">6000's</td>
                              <td width="80%">Expenditures/Deductions</td>
                          </tr>
                          <tr>
                              <td width="20%">7000's</td>
                              <td width="80%">Expenditures/Deductions</td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </td>
      </tr>
    </tbody>
  </table>

</div>